/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */
'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2;

import FormattedMessage from 'I18n/components/FormattedMessage';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { ENTERPRISE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import styled from 'styled-components';
import { TabEnum } from '../constants/TabConfig';
import { CREATE_A_BUNDLE, SCREENS } from '../constants/Tracking';
import { countrySelector } from '../selectors/CountrySelectors';
import { activeCurrencySelector } from '../selectors/CurrencySelectors';
import { useMon606LogExposure } from '../selectors/ExperimentTreatmentSelectors';
import { hasPricingAndPurchasingFailedSelector, hasPricingAndPurchasingSucceededSelector } from '../selectors/LoadingStateSelectors';
import { suiteProductConfigurationsSelector } from '../selectors/ProductConfigsSelectors';
import { hasPaidHubInProductInventorySelector, hasProductVersionInProductInventorySelector } from '../selectors/ProductInventorySelectors';
import { useTrackRetail } from '../selectors/RetailSelectors';
import { useQueryParamsEffect } from '../utils/queryParamUtils';
import breakpoint from '../utils/responsiveBreakpoints';
import { useQueryParamTerm } from '../utils/stateUtils';
import RussianBlockedBanner from './banners/RussianBlockedBanner';
import CurrencyPicker from './common/CurrencyPicker';
import PageContainer from './common/PageContainer';
import PhoneSupport from './common/PhoneSupport';
import FailedLoadBanner from './loading/FailedLoadBanner';
import AddonsAndServicesPickerList from './plan-builder/AddonsAndServicesPickerList';
import HubPlanPickerList from './plan-builder/HubPlanPickerList';
import PlanBuilder from './plan-builder/PlanBuilder';
import SummaryColumn from './plan-builder/SummaryColumn';
import TabLayout from './tabs/TabLayout';
const PageTitle = styled.div.withConfig({
  displayName: "BundlePage__PageTitle",
  componentId: "sc-11p9hjt-0"
})(["text-align:center;font-size:32px;margin-bottom:10px;font-weight:600;line-height:40px;", ""], breakpoint.tabletPortrait(_t || (_t = _`
    padding: 0 15px;
    text-align: left;
    margin-top: .98em ;
  `)));
const SubTitle = styled.div.withConfig({
  displayName: "BundlePage__SubTitle",
  componentId: "sc-11p9hjt-1"
})(["text-align:center;font-size:16px;margin-bottom:56px;", ""], breakpoint.tabletPortrait(_t2 || (_t2 = _`
    padding: 0 15px;
    text-align: left;
    margin-bottom: 30px;
  `)));
const FailedContentContainer = styled.div.withConfig({
  displayName: "BundlePage__FailedContentContainer",
  componentId: "sc-11p9hjt-2"
})(["max-width:1200px;margin:0 auto;padding:45px 0 0;"]);
const RightColumnWrapper = styled.div.withConfig({
  displayName: "BundlePage__RightColumnWrapper",
  componentId: "sc-11p9hjt-3"
})(["width:360px;"]);

const BundlePage = () => {
  useMon606LogExposure();
  useTrackRetail();
  const country = useSelector(countrySelector);
  const activeCurrencyCode = useSelector(activeCurrencySelector);
  useEffect(() => {
    getUsageTracker().setProperties({
      activeCurrencyCode,
      countryTerritory: country
    });
    getUsageTracker().track('pageView', {
      screen: SCREENS.CREATE_BUNDLE
    });
  }, []);
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const hasPricingAndPurchasingFailed = useSelector(hasPricingAndPurchasingFailedSelector);
  const initialProductConfigurations = useSelector(state => {
    if (!hasPricingAndPurchasingSucceeded || hasPaidHubInProductInventorySelector(state, {
      productLevels: [PROFESSIONAL, ENTERPRISE]
    })) return [];
    return suiteProductConfigurationsSelector(state, {
      productLevel: STARTER
    }).filter(({
      skuId
    }) => !hasProductVersionInProductInventorySelector(state, {
      skuId
    }));
  });
  const {
    queryParamTerm
  } = useQueryParamTerm();
  useQueryParamsEffect({
    term: queryParamTerm
  });
  return /*#__PURE__*/_jsx(TabLayout, {
    selectedPrimaryTab: TabEnum.BUNDLE,
    selectedSecondaryTab: TabEnum.CREATE_BUNDLE,
    children: /*#__PURE__*/_jsxs(PageContainer, {
      className: "p-y-10",
      children: [hasPricingAndPurchasingFailed && /*#__PURE__*/_jsx(FailedContentContainer, {
        children: /*#__PURE__*/_jsx(FailedLoadBanner, {
          hasFailed: hasPricingAndPurchasingFailed
        })
      }), hasPricingAndPurchasingSucceeded && /*#__PURE__*/_jsx(NavMarker, {
        name: "BUNDLE_PAGE"
      }), hasPricingAndPurchasingSucceeded && /*#__PURE__*/_jsx(RussianBlockedBanner, {}), /*#__PURE__*/_jsx(CurrencyPicker, {}), /*#__PURE__*/_jsx(PageTitle, {
        "data-selenium-id": "page-success",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "bundles.pageTitle"
        })
      }), /*#__PURE__*/_jsx(SubTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "bundles.subtitle"
        })
      }), /*#__PURE__*/_jsxs(PlanBuilder, {
        initialProductConfigurations: initialProductConfigurations,
        allowUpgradesToCrmSuite: true,
        trackingSource: CREATE_A_BUNDLE,
        screen: SCREENS.CREATE_BUNDLE,
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex-column",
          style: {
            flex: 1
          },
          children: [/*#__PURE__*/_jsx(HubPlanPickerList, {
            productLines: [MARKETING, SALES, SERVICE, CMS, OPERATIONS],
            useCompactTitle: false
          }), /*#__PURE__*/_jsx(AddonsAndServicesPickerList, {
            compact: false,
            defaultOpen: true,
            showServicesSection: true,
            screen: SCREENS.CREATE_BUNDLE
          })]
        }), /*#__PURE__*/_jsxs(RightColumnWrapper, {
          className: "m-left-10 flex-column",
          children: [/*#__PURE__*/_jsx(SummaryColumn, {
            shareLinkAnchor: "",
            hubsSignupProductOverride: "bundle"
          }), /*#__PURE__*/_jsx(PhoneSupport, {
            className: "m-top-5",
            phoneSourceId: "bundle",
            border: false,
            screen: SCREENS.CREATE_BUNDLE
          })]
        })]
      })]
    })
  });
};

export default BundlePage;